/* global angular*/

import './style.less';
import { sortBy, get, groupBy } from 'lodash';

export default function(
  $log,
  $q,
  $state,
  $filter,
  $stateParams,
  $timeout,
  ApiClass,
  RegulatorClass,
  ResolveClass,
  store
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.adminCss = $state.current.name === 'app.admin.employees.employee.compliance';

  vm.colorDict = {
    'Exceeding Benchmark': 'primary',
    'Behind Benchmark': 'warning',
    'In Danger': 'danger',
    'At Risk': 'danger'
  };

  vm.view = store.get('complianceTrackerView') || 'gauge';

  vm.changeTab = () => {
    $timeout(() => {
      const query = document.getElementsByClassName('compliance-gauge-message');
      const queryResult = angular.element(query).toArray();

      if (queryResult.length <= 1) return;

      const minHeight = queryResult.reduce((a, b) => (a.clientHeight > b.clientHeight ? a : b)).clientHeight;

      queryResult.forEach(elm => angular.element(elm).css('height', `${minHeight}px`));
    }, 0);
  };

  vm.setCollapse = () => {
    vm.collapse = !vm.collapse;
    store.set('complianceTrackerCollapse', vm.collapse);
  };

  vm.changeView = view => {
    vm.view = view;
    store.set('complianceTrackerView', view);
  };

  // Returns the annual requirement based off of most current year.
  vm.getAnnualRequirement = (cycles, selected, index) => {
    return get(
      cycles[selected],
      `cycle_limiter.min.annual.${index}.hours`,
      cycles[selected].cycle_limiter.annual.hours
    );
  };

  function getCollapse() {
    const storedValue = store.get('complianceTrackerCollapse');
    return storedValue == null ? ResolveClass.applicationSettings('complianceTracker').collapse : !!storedValue;
  }

  function activate() {
    vm.error = {};
    vm.loaded = false;
    vm.profileUid = $stateParams.employeeID || $stateParams.id;
    vm.collapse = getCollapse();

    const promises = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdTypeGet(
        { id: profile_uid, type: 'licenses', manage: false },
        {},
        {
          queryParams: {
            data_type: 'report',
            'include:showHidden': true
          }
        }
      )
    ];

    $q.all(promises)
      .then(([{ obj: regulatorsDict }, { data: { items: regs } }]) => {
        $log.debug('Compliance Tracker Data:', arguments);
        vm.regulatorDict = regulatorsDict;
        vm.licenses = [];

        vm.flatCompliance = regs;
        vm.flatCompDictArr = groupBy(regs, 'reg_id');

        Object.keys(vm.flatCompDictArr || {}).forEach(reg_id => {
          const cycles = sortBy(vm.flatCompDictArr[reg_id], 'date')
            .reverse()
            .map(comp => {
              const { group, cycle_limiter, cycle_total, cycle, gauges } = angular.copy(
                regulatorsDict[comp.reg_id][comp.reg_date]
              );

              if (!('cycle_limiter' in comp)) comp.cycle_limiter = cycle_limiter;
              if ('cycle' in comp.cycle_limiter) comp.cycle = comp.cycle_limiter.cycle;
              if ('prorate_cycle' in comp.cycle_limiter) comp.cycle = comp.cycle_limiter.prorate_cycle;
              if (!('cycle' in comp)) comp.cycle = cycle;
              if (!('cycle_total' in comp.cycle_limiter)) comp.cycle_limiter.cycle_total = cycle_total;
              if (!('group' in comp)) comp.group = group;
              if (!('gauges' in comp)) {
                comp.gauges = gauges.map(gauge => {
                  if (gauge.span && get(comp, `span.[${gauge.value}].hours.min`, false)) {
                    gauge.max = comp.span[gauge.value].hours.min;
                  }

                  if (gauge.span_count && get(comp, `span_count.[${gauge.value}].hours.min`, false)) {
                    gauge.max = comp.span_count[gauge.value].hours.min;
                  }

                  if (comp.cycle_limiter && comp.cycle_limiter.min && gauge.value in comp.cycle_limiter.min) {
                    gauge.max = comp.cycle_limiter.min[gauge.value];
                  }

                  if (comp.cycle_limiter && comp.cycle_limiter.max && gauge.value in comp.cycle_limiter.max) {
                    gauge.max = comp.cycle_limiter.max[gauge.value];
                  }

                  return gauge;
                });
              }

              return comp;
            });

          vm.flatCompDictArr[reg_id] = cycles;
          vm.licenses.push({ selected: 0, reg_id, prior: false, cycles, name: $filter('RegulatorBasicName')(reg_id) });
        });

        vm.loaded = true;

        vm.changeTab();
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/complianceTracker/controller.js